import React, { useState, useEffect } from 'react';
import { List, Skeleton, ConfigProvider, Image, Space, } from 'antd';
import '../styles/listaproductos.css'
import { obtenerInfoProductoEspecial,GetIdsProductsByFamily } from '../api/productoService';

/**
 * Componente para mostrar el listado de los productos del pedido
 * @param {productos} ListaProductos 
 * @returns vista con diseño de lista de productos
 */
export const ListaProductos = ({ productos,pedidoid,sucursalId }) => {

  const [initLoading, setInitLoading] = useState(true);
  const [list, setList] = useState([]);
  const ID_FAMILIA_ESPECIAL = 2135;
  useEffect(() => {
    const fetchInfo = async () => {
      const codigosEspecialesResponse = await GetIdsProductsByFamily(ID_FAMILIA_ESPECIAL);
      const codigosEspeciales = codigosEspecialesResponse.map(a => a.productoId);
      const productosConCambio = productos.filter(f => codigosEspeciales.includes(f.productoId));
      if (productosConCambio.length > 0) {
        try {
          const infoProductos = await obtenerInfoProductoEspecial(pedidoid,sucursalId);
          const productosActualizados = productosConCambio.map((producto) => {
            const info = infoProductos.find(p => p.producto === producto.producto);
            return {
              ...producto,
              descripcion: info?.descripcion || producto.descripcion,
              imagen: info?.imagenUrl || producto.imagen
            };
          });

          const nuevaLista = productos.map(p => {
            const modificado = productosActualizados.find(pa => pa.producto === p.producto);
            return modificado ? modificado : p;
          });

          setList(nuevaLista);
        } catch (error) {
          console.error("Error al obtener información de productos especiales:", error);
          setList(productos);
        } finally {
          setInitLoading(false);
        }
      } else {
        setList(productos);
        setInitLoading(false);
      }
    };

    fetchInfo();
  }, [productos]);

  const precioStyle ={
    padding:'8px'
  }
  const IconText = ({ descripcion, text }) => (
    <div>
      <Space className='custom-descripcion'>
        {descripcion}
      </Space>
      <br>
      </br>
      <Space className='custom-descripcion'>
        {text + "pz"}
      </Space>
    </div>
  );

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorTextDescription: 'black',
            borderRadiusLG: 0,
            padding: 5,
            paddingContentHorizontal: 30,
            paddingContentHorizontalLG: 33,
          },
          components: {
            List: {
              descriptionFontSize: 12,
            },
            Avatar: {
              containerSize: 40
            }
          }
        }}
      >
        <List
          className="demo-loadmore-list"
          loading={initLoading}
          itemLayout="horizontal"
          dataSource={list}
          renderItem={(item) => (
            <List.Item>
              <Skeleton avatar title={false} loading={item.loading} active>
                <List.Item.Meta
                  avatar={
                    <Image
                      width={50}
                      src={item.imagen}
                    />
                  }
                  title={<a>{item.name?.last}</a>}
                  description={<IconText descripcion={item.descripcion} text={item.cantidad} key="list-vertical-star-o" />}
                />
                <div style={precioStyle} className='custom-precioConIva'>${item.precioConIva}</div>
              </Skeleton>
            </List.Item>
          )}
        />
      </ConfigProvider>
    </>
  );
};
